import type { CSSProperties } from 'react';

export const railStyle: CSSProperties = {
  width: 220,
  flexShrink: 0,
  borderRight: '1px solid var(--color-border-soft)',
  background: 'color-mix(in srgb, var(--color-surface) 40%, transparent)',
  padding: '20px 12px',
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  position: 'sticky',
  top: 0,
  height: '100vh',
};

export const sectionLabelStyle: CSSProperties = {
  fontFamily: 'var(--font-mono)',
  fontSize: 10,
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  color: 'var(--color-text-mute)',
  padding: '0 10px',
  marginBottom: 4,
  marginTop: 8,
};

export function buildNavItemStyle(active: boolean): CSSProperties {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '8px 10px',
    borderRadius: 'var(--radius-md)',
    color: active ? 'var(--color-text)' : 'var(--color-text-dim)',
    background: active ? 'var(--color-surface-2)' : 'transparent',
    fontSize: 13,
    cursor: 'pointer',
    transition: 'background 0.12s, color 0.12s',
    position: 'relative',
    textDecoration: 'none',
    fontFamily: 'var(--font-sans)',
  };
}

export const navItemActiveBarStyle: CSSProperties = {
  position: 'absolute',
  left: -12,
  top: '50%',
  transform: 'translateY(-50%)',
  width: 2,
  height: 18,
  background: 'var(--color-accent)',
  borderRadius: 2,
};

export const badgeStyle: CSSProperties = {
  marginLeft: 'auto',
  fontFamily: 'var(--font-mono)',
  fontSize: 10,
  color: 'var(--color-accent)',
  background: 'var(--color-accent-soft)',
  padding: '1px 5px',
  borderRadius: 3,
};

export const bottomNavStyle: CSSProperties = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  height: 64,
  background: 'color-mix(in srgb, var(--color-bg) 90%, transparent)',
  backdropFilter: 'blur(20px)',
  borderTop: '1px solid var(--color-border-soft)',
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'space-around',
  zIndex: 30,
  paddingBottom: 'env(safe-area-inset-bottom)',
};

export function buildBottomItemStyle(active: boolean): CSSProperties {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    flex: 1,
    color: active ? 'var(--color-accent)' : 'var(--color-text-mute)',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'var(--font-sans)',
    fontSize: 10,
    textDecoration: 'none',
  };
}
